import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { Card } from "../components/ui/card";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

const STATUS_STYLE = {
  sent: { icon: CheckCircle2, color: "text-emerald-600 bg-emerald-100 dark:bg-emerald-900/30" },
  pending_keys: { icon: Clock, color: "text-amber-600 bg-amber-100 dark:bg-amber-900/30" },
  failed: { icon: XCircle, color: "text-red-600 bg-red-100 dark:bg-red-900/30" },
};

export default function NotificationsPage() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/notifications").then(r => setItems(r.data || [])).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-semibold">{t("notifications")}</h1>

      <Card className="border shadow-none overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[600px]">
            <thead className="bg-muted/50">
              <tr>
                <th className="text-start px-4 py-3 text-xs uppercase tracking-wider font-semibold text-muted-foreground">{t("notif_kind")}</th>
                <th className="text-start px-4 py-3 text-xs uppercase tracking-wider font-semibold text-muted-foreground">{t("notif_to")}</th>
                <th className="text-start px-4 py-3 text-xs uppercase tracking-wider font-semibold text-muted-foreground">{t("notif_subject")}</th>
                <th className="text-start px-4 py-3 text-xs uppercase tracking-wider font-semibold text-muted-foreground">{t("status")}</th>
                <th className="text-start px-4 py-3 text-xs uppercase tracking-wider font-semibold text-muted-foreground">{t("notif_when")}</th>
              </tr>
            </thead>
            <tbody>
              {items.map((n, i) => {
                const meta = STATUS_STYLE[n.status] || STATUS_STYLE.pending_keys;
                const Icon = meta.icon;
                return (
                  <tr key={n.id} className={`border-t border-border ${i%2 ? "bg-muted/20" : ""}`} data-testid={`notif-${n.id}`}>
                    <td className="px-4 py-3 uppercase text-xs font-mono">{n.kind}</td>
                    <td className="px-4 py-3 font-mono truncate max-w-[200px]">{n.to}</td>
                    <td className="px-4 py-3 truncate max-w-[280px]">{n.subject}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ${meta.color}`}>
                        <Icon className="w-3 h-3"/> {n.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 font-mono text-xs text-muted-foreground whitespace-nowrap">{n.at?.slice(0, 16)}</td>
                  </tr>
                );
              })}
              {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-muted-foreground">{t("no_notifications_yet")}</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
